<template>
  <div class="LegalPeopleInfo">
   <van-cell-group >
      <van-field
        readonly
        clickable
        :label="label"
        :value="this.$store.state.commonForms.livingText"
        :placeholder="placeholder"
        right-icon="arrow"
        class="term"
        @click="showLivingPlacePicker=true"
      />
      <van-popup v-model="showLivingPlacePicker" position="bottom" :style="{ height: '40%' }">
        <van-area :area-list="areaList"  @confirm='comfirmPlace'  @cancel="showLivingPlacePicker=false" />
      </van-popup>
    </van-cell-group>
  </div>
</template>

<script>
// @ is an alias to /src
// import { Field, version } from "vant";
// import ValidHoc from "../../../../components/valid";
import service from '@/request/api'; // 导入api接口
// const ValidVanField = ValidHoc(Field);
export default {
  name: 'LivingPlacePicker',
  props: [
    'label',
    'placeholder',
    'model',
  ],
  data() {
    return {
      showLivingPlacePicker: false,
      areaList: {},
    };
  },
  mounted() {
    service.CommonForms.getAreaList().then((res) => {
      this.areaList = res.data;
    }).catch((e) => {
      console.log(e);
    });
  },
  // computed: {
  //     borrowerAddress: {
  //         get() {
  //             return this.$store.state.loader.legalPeolpeInfo.borrowerAddress;
  //         },
  //         set (value) {
  //             this.$store.commit("loader/updateLoaderInfoForm", {
  //                 borrowerAddress: value,
  //             })
  //         }
  //     }
  // },
  methods: {
    comfirmPlace(value) {
      console.log(this.model.split('/'));
      const tempArry = this.model.split('/');
      this.showLivingPlacePicker = false;
      let temp = '';
      value.forEach((item) => {
        temp += `${item.name} `;
      });
      this.$store.commit('commonForms/updateForm', {
        [tempArry[0]]: value[0].name,
        [tempArry[1]]: value[1].name,
        [tempArry[2]]: value[2].name,
        [tempArry[3]]: value[2].code,
        livingText: temp,
      });
    },
  },
};
</script>
<style scoped>
.bgColor {
  background: #f8f8f9;
}
</style>
